"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customEvent = exports.stop = exports.start = exports.init = void 0;
const VERSION_PLACEHOLDER = "{version}";
const SDK_URL = `https://www.saola.ai/sdk/saola.${VERSION_PLACEHOLDER}.js`;
const win = typeof window !== "undefined" ? window : null;
let initialized = false;
const init = (accountToken, version = "latest", customOptions = {}) => {
    if (initialized || !win)
        return;
    setParams(accountToken, customOptions);
    injectSDK(version);
    initialized = true;
};
exports.init = init;
const start = () => {
    var _a;
    if (!((_a = win === null || win === void 0 ? void 0 : win.Saola) === null || _a === void 0 ? void 0 : _a.start))
        return;
    win.Saola.start();
};
exports.start = start;
const stop = () => {
    var _a;
    if (!((_a = win === null || win === void 0 ? void 0 : win.Saola) === null || _a === void 0 ? void 0 : _a.stop))
        return;
    win.Saola.stop();
};
exports.stop = stop;
const customEvent = (eventType, data) => {
    var _a;
    if (!((_a = win === null || win === void 0 ? void 0 : win.Saola) === null || _a === void 0 ? void 0 : _a.customEvent))
        return;
    win.Saola.customEvent(eventType, data);
};
exports.customEvent = customEvent;
const setParams = (accountToken, customOptions = {}) => {
    win.SaolaParams = { token: accountToken, options: customOptions };
};
const injectSDK = (version) => {
    const SDKScript = win.document.createElement("script");
    SDKScript.defer = true;
    SDKScript.src = SDK_URL.replace(VERSION_PLACEHOLDER, version);
    win.document.head.appendChild(SDKScript);
};
//# sourceMappingURL=index.js.map